import React,{useEffect} from 'react';



import './app.css';
import sweet from './img/enterprise-logo.png';
import "./forms.css";
import { ForgotPassword } from "./components/BeforeLogin/ForgotPassword";
import { Signup } from "./components/BeforeLogin/Signup";
import { Login } from "./components/BeforeLogin/Login";
import { Home } from "./components/Home";
import VisualizeFlow from './components/VisualizeFlow';
import {PAGE} from "./constants";
import { useState,useMemo} from 'react';
import {PageContext} from './PageContext';
import {LightTooltip} from './components/LightTooltip';
import { getLoggedInUserName, invalidateSession, isUserLoggedIn } from './apis/sessionUtil';
import { Auth } from 'aws-amplify';
import Profile from './components/Profile/Profile';
import {TestAPI} from './components/TestAPI';
import {SignupVC} from './components/BeforeLogin/SignupVC'

function App() {

  const [page, setPage] = useState(getDefaultPage());
  const [show, setShow] = useState(false);
  // const [userName,setUserName] = useState("");
  // const [verificationCode,setVerificationCode] = useState("");

  
  // useEffect(() => {
  //   if(page.toUpperCase() === PAGE.SIGNUPVC){
  //     const queryParams = new URLSearchParams(window.location.search);
  //     let un = queryParams.get('userName');
      
  //     setUserName(un);

  //     let vc = queryParams.get('verificationCode');
  //     console.log(`User name ${un} VerificationCode ${vc}`);
  //     setVerificationCode(vc);
  //   }
   
  // }, [page])

  const value = useMemo(
    () =>({page, setPage}),
    [page],
    
  );

  function isSubmissionPage(){
    const queryParams = new URLSearchParams(window.location.search);
    var page = queryParams.get('page');

    if(page === 'Submission')
      return true;
    else
      return false;
  }

  function handleProfileClick() {
    setShow(true);
  }

  function logout(event) {
    event.preventDefault();
    invalidateSession();
    Auth.signOut()
      .then((result) => console.log(result))
      .catch((err) => console.error(err));

    // setRender(true); //this is to trigger a render
    setPage(PAGE.LOGIN)
    console.log("Inside logout");
  }

  function showTest(e){
    e.preventDefault();
    setPage(PAGE.TEST)
  }

  const Logout = () => {
    return (
      
      <div className="logoutcontainer">
        
       
        
        
        <div className="logout">
          {/* <div>
            <LightTooltip title="Test">
              <a
                style={{ marginRight: "10px" }}
                href="#"
                target="_blank"
                onClick={(e)=>showTest(e)}
              >
                TEST
              </a>
            </LightTooltip>
          </div> */}
          <div>
            <LightTooltip title="Download Digital Assistant Zip">
              <a
                style={{ marginRight: "10px" }}
                href="https://autosmic-downloads.s3.us-west-1.amazonaws.com/consumer/index.html"
                target="_blank"
              >
                DOWNLOAD
              </a>
            </LightTooltip>
          </div>
          <div>
            <LightTooltip title={getLoggedInUserName()}>
           

              <a
                style={{ marginRight: "10px" }}
                href="#"
                onClick={handleProfileClick}
              >
                PROFILE
              </a>
            </LightTooltip>

            <LightTooltip title="Help Videos and Documentation">
              <a
                style={{ marginRight: "10px" }}
                href="https://www.youtube.com/playlist?list=PLUY5xJNivcMjGPrN-m2w3e6KPXIyFUxmj"
                target="_blank"
              >
                HELP
              </a>
            </LightTooltip>
          </div>
          <div>
            <LightTooltip title="Log out of your account">
              <a style={{ marginRight: "10px" }} href="#" onClick={logout}>
                LOGOUT
              </a>
            </LightTooltip>
          </div>
        </div>
      </div>
    );
  };

  function showLogout(){
    if(!isSubmissionPage()){

      if(isUserLoggedIn())
        return <Logout/>;
    }
 
  }

  const Header = () => {
    return (
      <header className="aheader">
        <div className="row" style={{ height: 30 }}>

        <div className="image-container">
          <LightTooltip title="Enterprise Automation Suite">
          <img className="title-img" alt=""  src={sweet} />
          </LightTooltip>
        </div>
          {/* <img className="title-center" alt="" src={title} /> */}
          {/* <label style={{color:'white', fontFamily:'Copperplate Gothic Light', fontSize:22, fontStyle:'bold'}} className="title-center">Enterprise Automation Suite </label> */}
          <label style={{color:'#f4f4f4', fontFamily:'Copperplate Gothic Light', fontSize:22, fontStyle:'bold'}} className="title-center">Enterprise Automation Suite </label>
          {/* <label style={{color:'royalblue', fontFamily:'Blackadder ITC', fontSize:30, fontStyle:'normal'}} className="title-center">Enterprise Automation Suite </label> */}
          {showLogout()}
        </div>
      </header>
    );
  };

  const Body = () => {

    switch(page) {
      case PAGE.LOGIN:
        return <Login/>;
      case PAGE.SIGNUP:
        return <Signup/>
      case PAGE.FORGETPASSWORD:
        return <ForgotPassword/>;
      case PAGE.HOME:
        return <Home/>;
      case PAGE.SUBMISSION:
        return <VisualizeFlow/>;
      case PAGE.SIGNUPVC:
        return <SignupVC/>
      case PAGE.TEST:
        return <TestAPI/>;
      default:
        console.log('Error');
        
    }
  }

  function getDefaultPage(){
    const queryParams = new URLSearchParams(window.location.search);
    var page = queryParams.get('page');
    // console.log('Page '+page);
    
    if (page === null || page.trim().length === 0){
      // console.log('Returning Login Page');
      
      return PAGE.LOGIN;
    }else{
      console.log('Returning '+page.toUpperCase());
  
     
      
      return page.toUpperCase();
    }
    
  }
  function getBodyStyle(){
    if(isUserLoggedIn()){
      return "abody bgImage"
    }else{
      return "abody"
    }
  }

  return (
    // <div className="main">
    <div >
    <Header/>

      <div className={getBodyStyle()}>
        <PageContext.Provider value={value}>
          { <Body/> }
        </PageContext.Provider>
        
      
      </div> 
      <footer>
        &copy; Copyright 2020-2024, Autosmic. All Rights Reserved.
        {/* </p> */}
      </footer>
      <Profile show={show} setShow={setShow}/>
    </div>
  );
  

 
}






export default App;

